import { Badge, makeStyles, tokens } from '@fluentui/react-components';
import { CalendarLtr20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import TitledCard from '../Layout/TitledCard';
import type { HomeUpcomingVisit } from './homeTypes';
import { useHomeListStyles } from './useHomeListStyles';

const useStyles = makeStyles({
  date: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '44px',
    height: '44px',
    flexShrink: 0,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground3,
    lineHeight: 1.1,
  },
  month: {
    fontSize: tokens.fontSizeBase100,
    textTransform: 'uppercase',
    color: tokens.colorNeutralForeground3,
  },
  day: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
});

const parts = (isoDate: string) => {
  const date = new Date(`${isoDate}T00:00:00`);
  return {
    month: date.toLocaleString(undefined, { month: 'short' }),
    day: date.getDate(),
  };
};

const UpcomingVisits = ({ visits }: { visits: HomeUpcomingVisit[] }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const list = useHomeListStyles();
  return (
    <TitledCard
      title={t('upcomingSiteVisits', 'Upcoming site visits')}
      icon={<CalendarLtr20Regular />}
    >
      <ul className={list.list}>
        {visits.map((visit) => {
          const { month, day } = parts(visit.date);
          return (
            <li key={visit.workId} className={list.row}>
              <span className={styles.date}>
                <span className={styles.month}>{month}</span>
                <span className={styles.day}>{day}</span>
              </span>
              <div className={list.text}>
                <span className={list.primary}>
                  {visit.workId} · {visit.address}
                </span>
                <span className={list.secondary}>
                  {visit.service} · {visit.turnaround}
                </span>
              </div>
              <Badge appearance="tint" color="informative">
                {t('scheduled', 'Scheduled')}
              </Badge>
            </li>
          );
        })}
      </ul>
    </TitledCard>
  );
};

export default UpcomingVisits;
